import { render, staticRenderFns } from "./index_m.vue?vue&type=template&id=4dc6e55b&scoped=true"
import script from "./index_m.vue?vue&type=script&lang=js"
export * from "./index_m.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc6e55b",
  null
  
)

export default component.exports